import { useLocation } from '@gatsbyjs/reach-router'
import { useCallback, useMemo } from 'react'

import { setAnalyticsEvent } from '../lib/analytics/state'
import { useClipboardCopy } from './useClipboardCopy'

const publishCopyEScriptEvent = ({
  copyText,
  version,
  campaign,
}: {
  copyText: string
  version?: string | null
  campaign?: string | null
}) => {
  if (!version || !campaign) return
  setAnalyticsEvent({
    event: 'copy_escript',
    escript_campaign: campaign,
    escript_version: version,
    escript_link: copyText,
  })
}

export function useClickToCopy(copyText: string) {
  const location = useLocation()
  const params = useMemo(() => {
    try {
      const url = new URL(copyText)
      return new URLSearchParams(url.search)
    } catch {
      return new URLSearchParams()
    }
  }, [copyText])

  const onCopy = useCallback(
    (text: string) => {
      if (location.pathname.includes('/escript')) {
        const campaign = params.get('ec')
        const version = params.get('v')
        publishCopyEScriptEvent({ copyText: text, version, campaign })
      }
    },
    [location.pathname, params],
  )

  const { copied, copyToClipboard, resetCopied } = useClipboardCopy({ text: copyText, onCopy })

  return { copied, copyToClipboard, resetCopied }
}
